import '../sentry/sentryInit'
import { Application } from '@hotwired/stimulus'
import Authentication_controller from '../controllers/authentication_controller';

const application = Application.start()
// application.debug = true
// Only load controllers we use when logged out
application.register('authentication', Authentication_controller)
;(window as any).Stimulus = application
